/**
 * Array of objects with fields:
 * @type {Array<{value: string, label: string}>}
 *  - value: assigned as variation.id,
 *  - label: assigned as variation.variation_nicename,
 *
 * 3D devs, please read it assuming it will already be updated as soon as the 3D is requested, not before.
 */
const globalVisFacesFinitureHackFor3D = []

/**
 * Gets the finishes nice name by ID
 * @param {number} id Finish ID to look up
 * @returns {string|undefined} The nice name if found, undefined if not found
 */
export function getVisFacesFinitureNiceNameById(id) {
    // noinspection EqualityComparisonWithCoercionJS
    return globalVisFacesFinitureHackFor3D.find((f) => f.value && f.value == id)?.label
}

/**
 * Resets the global finishes array by removing all elements
 * @param {Array<{value: string, label: string}>} [newArray] Optional array to set after reset
 * @returns {void}
 */
export function resetGlobalVisFacesFinitureHackFor3D(newArray) {
    globalVisFacesFinitureHackFor3D.splice(0, globalVisFacesFinitureHackFor3D.length)
    if (newArray?.length) {
        globalVisFacesFinitureHackFor3D.push(...newArray)
    }
}
